import { type PropsWithChildren } from 'react';
import { classNames } from '@utils/classNames';
import { ActionButtons } from './defaultView/ActionButtons';
import { useUserContext } from '@src/contexts/useUserContext';
import { Header } from './defaultView/Header';

type DefaultViewProps = {
  header: string;
  actionButtons?: JSX.Element;
};

export const DefaultView = ({
  header,
  actionButtons,
  children,
}: PropsWithChildren<DefaultViewProps>) => {
  const { user } = useUserContext();

  return (
    <div className="h-full flex flex-col sm:gap-4">
      <Header header={header} avatar={user.avatar?.id} className="order-1" />
      <ActionButtons className="order-3 sm:order-2">
        {actionButtons}
      </ActionButtons>
      <div
        className={classNames(
          'bg-white overflow-y-auto',
          'h-full px-4 sm:p-6',
          'sm:border sm:border-blue-100 sm:rounded-xl',
          'order-2 sm:order-3',
        )}
      >
        {children}
      </div>
    </div>
  );
};
